import { createAction, props } from '@ngrx/store';

export const TELL_US_ABOUT_YOURSELF = '[CreateAccount] TellUsAboutYourself';
export const MOBILE_IDENTITY = '[CreateAccount] MobileIdentity';
export const IDENTITY_CONFIRMATION = '[CreateAccount] IdentityConfirmation';
export const CHANGE_MOBILE = '[CreateAccount] ChangeMobile';
export const CHANGE_BUSINESS = '[CreateAccount] ChangeBusiness';
export const CHANGE_EMAIL = '[CreateAccount] ChangeEmail';
export const LEGACY_UPGRADE = '[CreateAccount] LegacyUpgrade';
export const ALL = '[CreateAccount] ALL';
export const CODE_IDENTITY = '[CreateAccount] CodeIdentity';
export const CLIENT_NUMBER = '[CreateAccount] ClientNumber';
export const LOGIN = '[CreateAccount] Login';

export const TellUsAboutYourselfAction = createAction(
  TELL_US_ABOUT_YOURSELF,
  props<{
    registeredCompanyName: string;
    firstName: string;
    lastName: string;
    email: string;
    heardAboutUsId: number;
    howDidYouHearAboutUs: string;
    heardAboutUsDetails: string;
  }>(),
);
export const MobileIdentityAction = createAction(
  MOBILE_IDENTITY,
  props<{
    mobilePhoneNumber: string;
    businessPhoneNumber: string;
  }>(),
);
export const ChangeMobileAction = createAction(
  CHANGE_MOBILE,
  props<{
    mobilePhoneNumber: string;
  }>(),
);
export const ChangeBusinessAction = createAction(
  CHANGE_BUSINESS,
  props<{
    businessPhoneNumber: string;
  }>(),
);
export const ChangeEmailAction = createAction(
  CHANGE_EMAIL,
  props<{
    email: string;
  }>(),
);
export const CodeIdentityAction = createAction(
  CODE_IDENTITY,
  props<{
    code: string;
  }>(),
);
export const ClientNumberAction = createAction(
  CLIENT_NUMBER,
  props<{
    clientNumber: string;
  }>(),
);
export const AllAction = createAction(
  ALL,
  props<{
    registeredCompanyName: string;
    firstName: string;
    lastName: string;
    email: string;
    heardAboutUsId: number;
    howDidYouHearAboutUs: string;
    heardAboutUsDetails: string;
    mobilePhoneNumber: string;
    businessPhoneNumber: string;
  }>(),
);
export const LegacyUpgradeAction = createAction(
  TELL_US_ABOUT_YOURSELF,
  props<{
    registeredCompanyName: string;
    heardAboutUsId: number;
    howDidYouHearAboutUs: string;
    heardAboutUsDetails: string;
  }>(),
);

export const LoginAction = createAction(
  LOGIN,
  props<{
    firstName: string;
    lastName: string;
    email: string;
  }>(),
);

export type All =
  | ReturnType<typeof TellUsAboutYourselfAction>
  | ReturnType<typeof MobileIdentityAction>
  | ReturnType<typeof ChangeMobileAction>
  | ReturnType<typeof ChangeBusinessAction>
  | ReturnType<typeof ChangeEmailAction>
  | ReturnType<typeof CodeIdentityAction>
  | ReturnType<typeof ClientNumberAction>
  | ReturnType<typeof LegacyUpgradeAction>
  | ReturnType<typeof LoginAction>
  | ReturnType<typeof AllAction>;
